function number(value, decimal = 0) {
  let n = value

  if (typeof n === 'string') {
    n = parseFloat(n)
  }

  if (Number.isFinite(n)) {
    return n.toFixed(decimal).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
  }
}

function currency(value, decimal) {
  const n = number(value, decimal)

  return n ? `$${n}` : n
}

function aprRange(min, max) {
  const aprMin = parseFloat(min),
    aprMax = parseFloat(max)

  if (isNaN(aprMax) || isNaN(aprMin)) {
    return
  }

  if (aprMin === aprMax) {
    return `${number(aprMin, 2)}%`
  }

  return `${number(aprMin, 2)}% - ${number(aprMax, 2)}%`
}

function apr(apr) {
  const n = number(apr, 2)

  return n ? `${n}%` : n
}

function month(months) {
  const n = parseInt(months)

  if (!n) {
    return
  }

  return `${n} ${n == 1 ? 'month' : 'months'}`
}

function balance(fixed, percent) {
  const fixedValue = parseFloat(fixed),
    percentValue = parseFloat(percent)

  if (percentValue) {
    return `${number(percentValue)}%`
  }

  if (fixedValue) {
    return currency(fixedValue)
  }
}

function defaultValue(value, defaultValue) {
  return value || defaultValue
}

export {
  number,
  currency,
  aprRange,
  apr,
  month,
  balance,
  defaultValue
}
